import React from "react";
import { Spin } from "antd";

export default class Loading extends React.Component {
  static defaultProps = {
    height: "200px",
    message: "Loading...",
  };
  render() {
    const { height, message, indicator } = this.props;
    return (
      <div className="loading-container" style={{ height }}>
        <Spin tip={message} indicator={indicator ? indicator : undefined} />
      </div>
    );
  }
}
